###
# Передаваемые параметры
#   model - модель содержащая объект вида:
#     [
#       {
#         "items":[
#           {
#             "name":"белый",
#             "price":"100"
#           },
#           {
#             "name":"черный",
#             "price":"100"
#           }
#         ],
#         "max":1,
#         "min":1,
#         "multiple":false,
#         "name":"Хлеб"
#       },
#       ...
#     ]
###
App.DishConfiguratorComponent = Em.Component.extend

  env: Em.inject.service('environment')
  store:   Em.inject.service('store')

  dish: null

  disabled: false
  canEdit:  Em.computed.not('disabled')
  cantEdit: Em.computed.alias('disabled')
  v2:       Em.computed.or('dish.has_modifier_scheme', 'env.features.newConfigurator')

  hasConfigurator: (->
    @get('dish.options') and @get('dish.options.length') > 0
  ).property('dish.options.@each')

  actions:
    createModifierScheme: ->
      modifier_scheme = @get('dish').set 'modifier_scheme',
        @get('store').createRecord 'modifier_scheme',
          draft_configurable_id   : @get('dish.id')
          base_price              : @get('dish.price')
        # modifier_scheme_items   : []

    addModifierGroupItem: () ->
      view_order = @get('dish.modifier_scheme.modifier_scheme_items').map((v) -> v.get('view_order')).sort().reverse()[0] || 0
      @get('dish.modifier_scheme.modifier_scheme_items').pushObject @get('store').createRecord('modifier_scheme_item', {view_order: view_order + 1})

    deleteModifierGroupItem: (group) ->
      group.deleteFromScheme() if confirm(Em.I18n.t 'configurator.confirm.remove_group_binding')

    destroyModifierScheme: ->
      @get('dish').set('modifier_scheme', null) if confirm(Em.I18n.t 'configurator.confirm.remove_modifier_scheme')

    addConfiguration: ->
      return if @get('v2')
      unless @get('dish.options')
        @get('dish').set('options', Em.A([]))

      m = Em.Object.create
        items: Em.A([])
        max: 1
        min: 1
        multiple: false
        name: Em.I18n.t 'dish_edit.configurator.new_configurator_title', ordinal: @get('dish.options.length') + 1

      @get('dish.options').pushObject(m)

    deleteConfiguration: (o) ->
      return if @get('v2')
      @get('dish.options').removeObject(o)

    addLine: (config) ->
      return if @get('v2')
      if not Em.isArray(config.get('items'))
        config.set('items', Em.A([]))

      line = Em.Object.create
        name: null
        price: 0
        focus: true

      config.get('items').pushObject(line)


    deleteLine: (line) ->
      return if @get('v2')
      @model.forEach (config) ->
        config.get('items').removeObject(line)

